import React, { useState, useEffect, useRef } from "react";
import { X, Megaphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import gsap from "gsap";
import { WEBSITE_DETAILS } from "@/config";
import { openExternalLink } from "@/utils/contactActions";

const TopBanner = () => {
    const [isVisible, setIsVisible] = useState(true);
    const bannerRef = useRef(null);

    useEffect(() => {
        if (isVisible && bannerRef.current) {
            gsap.fromTo(
                bannerRef.current,
                { y: -50, opacity: 0 },
                { y: 0, opacity: 1, duration: 0.5, ease: "power3.out", delay: 1 }
            );
        }
    }, [isVisible]);

    const handleClose = () => {
        gsap.to(bannerRef.current, {
            y: -50,
            opacity: 0,
            duration: 0.3,
            onComplete: () => setIsVisible(false),
        });
    };

    const handleCTA = () => {
        openExternalLink(WEBSITE_DETAILS.socialMedia.whatsapp)
    };

    if (!isVisible) return null;

    return (
        <div
            ref={bannerRef}
            className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white p-2 sticky top-0 z-[60]"
        >
            <div className="max-w-7xl mx-auto flex items-center justify-between gap-2 text-center sm:text-left">
                <div className="flex sm:items-center gap-2 text-xs sm:text-sm md:text-base font-medium">
                    <Megaphone className="h-5 w-5 animate-bounce shrink-0" />
                    <span>
                        Limited Time Offer: Get a <strong>FREE SEO Audit</strong> with any
                        Web Design Package!
                    </span>
                </div>
                <div className="items-center gap-4 flex">
                    <Button
                        size="sm"
                        variant="secondary"
                        className="hidden sm:block bg-white text-indigo-600 hover:bg-gray-100 font-bold border-0"
                        onClick={handleCTA}
                    >
                        Claim Offer
                    </Button>
                    <button
                        onClick={handleClose}
                        className="text-white/80 hover:text-white transition-colors"
                        aria-label="Close banner"
                    >
                        <X className="h-5 w-5" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TopBanner;
